<script lang="ts">
  import Modal from "$app/components/Modal.svelte"
  import RecognitionDialog from "$app/Pages/Plans/Recognitions/RecognitionDialog.svelte"
  import { clapIcon } from "$app/utils/icons"

  let props = $props()
  let { plan_id } = props

  let openModal = $state(false)
</script>

<button
  class="flex flex-nowrap items-center px-4 py-2 border border-gray-400 shadow-lg text-sm font-medium rounded-full text-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 {props.class ||
    ''}"
  type="button"
  data-name="send-recognition"
  onclick={() => (openModal = true)}
>
  {@html clapIcon}
  <div
    class="hidden ml-4 whitespace-nowrap font-bold lg:inline text-xs md:text-sm"
  >
    Send Recognition
  </div>
</button>

<Modal bind:open={openModal} closeButton={true} closeOnEsc={true} large={true}>
  <RecognitionDialog {plan_id} oncreated={() => (openModal = false)} />
</Modal>
